import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { ProjectDocFolder } from "../../models/ProjectDocFolder";
import { NewInput } from '../../../../components/synced/ui/NewInput/NewInput';
import { NewButton } from '../../../../components/synced/ui/NewButton/NewButton';


interface EditSectionDialogProps {
  visible: boolean;
  folder: ProjectDocFolder;
  onSave: (folder: ProjectDocFolder) => void;
  onCancel: () => void;
}

export const EditSectionDialog: React.FC<EditSectionDialogProps> = ({ visible, folder, onSave, onCancel }) => {
  const [data, setData] = React.useState<ProjectDocFolder>({ ...folder });
  React.useEffect(() => setData({ ...folder }), [folder]);


  const isDataValid = React.useCallback((): boolean => {
    return Boolean(data.Title);
  }, [data]);


  const footer = (
    <div className="pd-dialog-footer">
      <NewButton variant="secondary" icon="fa-solid fa-xmark" onClick={onCancel}>Отменить</NewButton>
      <NewButton variant="primary" icon="fa-solid fa-check" disabled={!isDataValid()} onClick={() => onSave(data)}>Сохранить</NewButton>
    </div>
  );

  return (
    <React.Fragment>
      <Dialog
        footer={footer}
        focusOnShow={false}
        contentStyle={{ overflow: `visible` }}
        className="pd-dialog"
        header={(folder?.Id ?? 0) > 0 ? "Изменение раздела" : "Добавление раздела"}
        visible={visible}
        onHide={onCancel}>
        <div className="pd-dialog-body">
          <div className="pd-dialog-field">
            <span className="pd-dialog-label">Название</span>
            <NewInput
              type="text"
              className="w-100"
              placeholder="Выберите название"
              value={data.Title}
              onChange={(e) => setData({ ...data, Title: e.currentTarget.value })} />
            {!data.Title && <small className="pd-field-error">Заполните название</small>}
          </div>
          <div className="pd-dialog-field">
            <span className="pd-dialog-label">Шифр</span>
            <NewInput
              type="text"
              className="w-100"
              placeholder="Введите шифр"
              value={data.Cypher}
              onChange={(e) => setData({ ...data, Cypher: e.currentTarget.value })} />
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
}
